import React from 'react';
import { Box } from '@mui/material';
import { useMutation } from 'react-query';
import { useRecoilState } from 'recoil';
import axios, { endPoints } from 'api/request';
import { OrderPayload } from 'pages/service-account-creation/store';
import { ACTIVE_DIRECTORY_ACCOUNT_TYPE } from 'pages/service-account-creation/constant';
import Select from 'components/select';

const MyPamSafeDropdown = () => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [order, setOrder] = useRecoilState(OrderPayload);
    const [pamSafeOptions, setPamSafeOptions] = React.useState([]);
    const myPamSafeApi = useMutation((payload) => axios.post(endPoints.serviceAccountCreation.myPamSafeList, payload));

    React.useEffect(() => {
        const gpid = order?.appOwnerDetails?.gpid;
        const isActiveDirectory = order?.accountType === ACTIVE_DIRECTORY_ACCOUNT_TYPE;

        if (isActiveDirectory && gpid && order?.environment) {
            myPamSafeApi.mutate(
                { gpid: [gpid], environment: order.environment },
                {
                    onSuccess: (data) => {
                        const list = data?.data?.data?.[gpid] || [];
                        const mappedOptions = list.map((item) => {
                            return {
                                label: item,
                                value: item,
                            };
                        });
                        setPamSafeOptions(mappedOptions);
                    },
                    onError: () => {
                        setPamSafeOptions([]);
                        setOrder((prev) => ({ ...prev, selectedPamSafe: null }));
                    },
                }
            );
        } else {
            setPamSafeOptions([]);
            if (order?.selectedPamSafe) {
                setOrder((prev) => ({ ...prev, selectedPamSafe: null }));
            }
        }
    }, [order?.accountType, order?.appOwnerDetails?.gpid, order?.environment]);
    React.useEffect(() => {
        if (!order?.selectedPamSafe && order?.isTouched) setIsTouched(true);
        else setIsTouched(false);
    }, [order?.selectedPamSafe, order?.isTouched]);

    return (
        <Box sx={{ width: '100%' }} data-testid="my-pamsafe-dropdown-wrapper">
            <Select
                key="myPamSafeName"
                label="MyPam Safe Name *"
                options={pamSafeOptions}
                value={order?.selectedPamSafe || null}
                handleOnSelect={(newValue) => {
                    setOrder((prev) => ({ ...prev, selectedPamSafe: newValue?.value || null }));
                }}
                disabled={!order?.appOwnerDetails?.gpid}
                isLoading={myPamSafeApi.isLoading}
                isRequired={isTouched}
            />
        </Box>
    );
};

export default React.memo(MyPamSafeDropdown);
